import { lazy, Suspense } from "react";
import { Capacitor } from "@capacitor/core";
import UpgradePageIAP from "./UpgradePageIAP";
import Spinner from "@/components/Spinner";

// App Store builds (`vite build --mode ios`, see .env.ios) must not contain
// the web checkout at all — Apple's 3.1.1 review flags Stripe/NowPayments
// code found inside the binary even when no UI path reaches it. The env check
// below is replaced with a literal at build time, so the dead branch and the
// entire UpgradePageWeb module graph (Stripe SDK, live key, NowPayments) are
// dropped from the iOS bundle.
const UpgradePageWeb =
  import.meta.env.VITE_IOS_BUILD === "true"
    ? null
    : lazy(() => import("./UpgradePageWeb"));

export default function UpgradePageSelector() {
  if (Capacitor.isNativePlatform() || !UpgradePageWeb) {
    return <UpgradePageIAP />;
  }
  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center w-full h-[60vh]">
          <Spinner />
        </div>
      }
    >
      <UpgradePageWeb />
    </Suspense>
  );
}
